<template>
  <!-- SLIDER -->
  <section class="image_cabecera">
    <img src="@/assets/img/slider1.jpg" />
    <div class="row">
      <div class="col col-6 wrap-text">
        <div class="text">
          <h3>Murcia Barroca</h3>
          <h2>{{ ruta.titulo }}</h2>
        </div>
      </div>
    </div>

    <div class="row wmax slider-controls">
      <div class="col col-6">
        <a @click="$router.go(-1)"><img src="@/assets/img/flecha_left.svg" width="30" /> ATRÁS</a>
      </div>
    </div>
  </section>
  <!-- .SLIDER -->

  <section class="wmax intro">
    <div class="row">
      <div class="col col-12">
        <span id="title_cat" class="nombre_cat">RUTAS</span>
        <h2>{{ ruta.titulo }}</h2>
        <p style="font-weight: 600; margin-bottom: 30px">
          {{ ruta.descripcion }}
        </p>
      </div>
    </div>
  </section>

  <!-- contenido -->
  <section class="wmax contenido_lugar">
    <div class="row">
      <div class="col col-12">
        <div v-html="ruta.contenido"></div>
      </div>
    </div>
  </section>
  <!-- .contenido -->

  <section class="wmax contenido_lugar pb-8">
    <div class="row">
      <div class="col col-xs-12 col-6">
        <h3><strong>Esta ruta contiene los siguientes lugares:</strong></h3>

        <div class="row item_lugar_ruta">
          <img src="@/assets/img/pin/pin1.png" width="40" />
          <h3>San Juan de Dios</h3>
        </div>
        <div class="row item_lugar_ruta">
          <img src="@/assets/img/pin/pin2.png" width="40" />
          <h3>San Juan Bautista</h3>
        </div>
        <div class="row item_lugar_ruta">
          <img src="@/assets/img/pin/pin3.png" width="40" />
          <h3>Santa Eulalia</h3>
        </div>
        <div class="row item_lugar_ruta">
          <img src="@/assets/img/pin/pin4.png" width="40" />
          <h3>Iglesia Conventual de La Merced</h3>
        </div>

      </div>

      <div class="col col-xs-12 col-6">
        <div id="map" style="width: 100%; height: 400px">
          <GMapMap :center="{ lat: 37.9857258, lng: -1.1269742 }" :zoom="16" map-type-id="terrain" :options="mapOptions">
            <GMapMarker :key="index" v-for="(location, index) in locations"
              :position="{ lat: location.lat, lng: location.lng }"
              :icon="require('@/assets/img/pin/pin' + (index + 1) + '.png')" :title="location.name"
              class="floating-marker" />
            <GMapPolyline :path="locations" :options="{
              strokeColor: '#c9a167',
              strokeOpacity: 0.8,
              strokeWeight: 4,
            }" />
          </GMapMap>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      ruta: [],
      loading: true,
      nombreCategoria: null,
      locations: [
        { lat: 37.983231, lng: -1.128116, name: "Iglesia de San Juan de Dios" },
        { lat: 37.983291, lng: -1.1256011, name: "Iglesia de San Juan Bautista" },
        { lat: 37.985, lng: -1.124722222, name: "Iglesia de Santa Eulalia" },
        { lat: 37.9875, lng: -1.126941, name: "Iglesia Conventual de La Merced" },
      ],
      mapOptions: {
        styles: [
          {
            featureType: "all",
            elementType: "geometry",
            stylers: [{ color: "#f5f1e4" }], // Gris claro para la geometría
          },
          {
            featureType: "all",
            elementType: "labels.text.fill",
            stylers: [{ color: "#333333" }], // Gris oscuro para el texto
          },
          {
            featureType: "all",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#efe4c1" }], // Blanco para el trazo del texto
          },
          {
            featureType: "road", // Esto se aplica a las carreteras
            elementType: "geometry.fill", // Esto se aplica al relleno de las carreteras
            stylers: [{ color: "#e5dbbb" }], // Aquí puedes poner el color que prefieras para las carreteras
          },
        ],
      },
    };
  },
  created() {
    this.loadRuta();
  },
  methods: {
    loadRuta() {
      const rutaId = this.$route.params.id;
      axios
        .get(`https://murciabarroca.es/api/getRuta/${rutaId}`)
        .then((response) => {
          this.ruta = response.data.data;
        })
        .catch((error) => {
          console.error("Error al obtener los datos:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style>
.gmap-polyline {}
</style>
